import { gql } from "@apollo/client";

export default gql`
  query getAiProductImageIndexes{
    getAiProductImageIndexes{
        success
        data{
            customerId
            customerName
            index{
                enabled
                state
                progressPercent
                counts{
                    images{
                        total
                        indexed
                        pending
                        failed
                    }
                    listings
                    products
                    lastIndexedAt
                }
                plannedAt
                shops{
                    shopId
                    type
                    connectionStatus
                    images{
                        total
                        indexed
                        pending
                        failed
                    }
                    listings
                }
                errors{
                    reason
                    images
                }
                usage{
                    total{
                        indexedImages
                        queryImages
                        estimatedCostUsd
                    }
                    last30Days{
                        indexedImages
                        queryImages
                        estimatedCostUsd
                    }
                }
            }
            error
        }
        code
        message
    }
}
`
